<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.47532 12.7502L7.25032 16.5252C8.80032 18.0752 11.317 18.0752 12.8753 16.5252L16.5337 12.8668C18.0837 11.3168 18.0837 8.80016 16.5337 7.24183L12.7503 3.47516C11.9587 2.6835 10.867 2.2585 9.75032 2.31683L5.58365 2.51683C3.91698 2.59183 2.59198 3.91683 2.50865 5.57516L2.30865 9.74183C2.25865 10.8668 2.68365 11.9585 3.47532 12.7502Z" stroke="url(#paint0_linear_7317_8049)" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.91634 10.0002C9.06693 10.0002 9.99967 9.06742 9.99967 7.91683C9.99967 6.76624 9.06693 5.8335 7.91634 5.8335C6.76575 5.8335 5.83301 6.76624 5.83301 7.91683C5.83301 9.06742 6.76575 10.0002 7.91634 10.0002Z" stroke="url(#paint1_linear_7317_8049)" stroke-width="1.25" stroke-linecap="round" />
    <defs>
      <linearGradient id="paint0_linear_7317_8049" x1="-0.145166" y1="-10.6087" x2="25.2197" y2="-6.0093" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_7317_8049" x1="5.1698" y1="2.33234" x2="12.0368" y2="3.5763" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
